import React from 'react';

const ProjectGallery = () => {
  return (
<>
<div className='bg-slate-50 min-h-screen'>
<div className="container mx-auto p-6">
      <h1
        class="font-extrabold text-center text-transparent text-8xl bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500"
      >
        CssGenerators
      </h1>
      <h2 className='text-4xl font-bold my-10 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500'>A free collection of Css Generating web apps</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gradient-to-br from-blue-500 to-purple-500 shadow-violet-300 shadow-lg rounded-lg">
          <img
            src="buttonify.png"
            alt="buttonify"
            className="w-full object-cover rounded-t-lg"
          />
          <div className="p-4">
            <h3 className="text-lg font-semibold text-white mb-2">Buttonify</h3>
            <p className="text-gray-100 mb-4">
              A free Web App where you can Generate Modern Buttons easily.
            </p>
            <a
              href="https://buttonify.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-100 text-slate-600 font-bold py-2 px-4 rounded-lg shadow-md transition-all duration-200"
            >
              View Project
            </a>
          </div>
        </div>
        <div className="bg-gradient-to-br from-blue-500 to-purple-500 shadow-violet-300 shadow-lg rounded-lg">
          <img
            src="shadowgenerator.png"
            alt="shadowgenerator"
            className="w-full object-cover rounded-t-lg"
          />
          <div className="p-4">
            <h3 className="text-lg font-semibold text-white mb-2">Shadow Generator</h3>
            <p className="text-gray-100 mb-4">
              A free Web App where you can easily Generate css Box-Shadow.
            </p>
            <a
              href="https://shadowgenerator.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-100 text-slate-600 font-bold py-2 px-4 rounded-lg shadow-md transition-all duration-200"
            >
              View Project
            </a>
          </div>
        </div>
        <div className="bg-gradient-to-br from-blue-500 to-purple-500 shadow-violet-300 shadow-lg rounded-lg">
          <img
            src="tailwindgradientgenerator.png"
            alt="tailwindgradientgenerator"
            className="w-full object-cover rounded-t-lg"
          />
          <div className="p-4">
            <h3 className="text-lg font-semibold text-white mb-2">Tailwind Gradient Generator</h3>
            <p className="text-gray-100 mb-4">
              An amazing Web App, which can Generate Css for specifically TailwindCss.
            </p>
            <a
              href="https://tailwindgradientgenerator.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-100 text-slate-600 font-bold py-2 px-4 rounded-lg shadow-md transition-all duration-200"
            >
              View Project
            </a>
          </div>
        </div>
      </div>

    </div>
</div>
</>
  );
};

export default ProjectGallery;
